import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { $post } from './store/api';

function ResetPassword({ resetToken, onDone }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('A két jelszó nem egyezik.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await $post('auth/reset-password', { token: resetToken, Jelszo: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Érvénytelen vagy lejárt link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <div className="auth-logo">
          <img
            src="https://www.presentperfect.xyz/wp-content/uploads/2018/11/pp_logo_head_mobile.png"
            alt="Present Perfect"
          />
        </div>
        <h2 className="auth-title">Új jelszó beállítása</h2>
        {done ? (
          <>
            <Alert variant="success" style={{ fontSize: 14 }}>
              A jelszavad sikeresen megváltozott!
            </Alert>
            <Button variant="primary" className="w-100" onClick={onDone}>
              Bejelentkezés
            </Button>
          </>
        ) : (
          <>
            {error && <Alert variant="danger" className="py-2 px-3" style={{ fontSize: 14 }}>{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Új jelszó</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Legalább 8 karakter"
                  required
                  minLength={8}
                  autoFocus
                />
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>Jelszó megerősítése</Form.Label>
                <Form.Control
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="Jelszó ismét"
                  required
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                {loading ? 'Mentés…' : 'Jelszó mentése'}
              </Button>
            </Form>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
